import "./index.css";
import App from "./App";
import { mountWithI18nProvider } from "./mountWithI18n";
import {
  setDevMockContext,
  DEV_SCREEN_STORAGE_KEY,
  type ScreenName,
} from "./utils/devMockContext";

function hasUniversalLoginContext(): boolean {
  return !!(
    typeof window !== "undefined" &&
    (window as { universal_login_context?: unknown }).universal_login_context
  );
}

async function initializeApp() {
  // Inject mock Auth0 context when:
  // 1. Dev mode (npm run dev), OR
  // 2. Production build visited directly (e.g. cdn.propsman.com?preview=1) — Auth0 sets context when embedded; visiting CDN directly has no context.
  const saved = (
    typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem(DEV_SCREEN_STORAGE_KEY)
      : null
  ) as ScreenName | null;
  const search =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : null;
  const urlScreen = search?.get("screen") as ScreenName | null;
  const validScreens: ScreenName[] = [
    "login-id",
    "login-password",
    "mfa-sms-challenge",
    "signup",
    "signup-id",
    "signup-password",
  ];
  const defaultScreen =
    (urlScreen && validScreens.includes(urlScreen) ? urlScreen : null) ??
    saved ??
    "login-id";

  if (import.meta.env.DEV) {
    setDevMockContext(defaultScreen);
  } else if (!hasUniversalLoginContext()) {
    const isPreview = search?.get("preview") === "1";
    if (isPreview) {
      setDevMockContext(defaultScreen);
      (window as { __ACUL_PREVIEW_MODE__?: boolean }).__ACUL_PREVIEW_MODE__ =
        true;
    } else {
      (window as { __ACUL_NO_CONTEXT__?: boolean }).__ACUL_NO_CONTEXT__ = true;
    }
  }

  await mountWithI18nProvider(<App />);
}

initializeApp();
